import { createI18n } from 'vue-i18n'
import en from './locales/en'
import zhCN from './locales/zh-CN'
import zhTW from './locales/zh-TW'

// 从 localStorage 获取保存的语言，如果没有则使用浏览器语言
const getDefaultLocale = () => {
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale) {
    return savedLocale
  }

  // 获取浏览器语言
  const browserLang = navigator.language || navigator.userLanguage

  if (browserLang.startsWith('zh')) {
    // 判断是简体还是繁体
    if (browserLang === 'zh-TW' || browserLang === 'zh-HK' || browserLang === 'zh-MO') {
      return 'zh-TW'
    }
    return 'zh-CN'
  }

  return 'en'
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getDefaultLocale(), // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages: {
    en,
    'zh-CN': zhCN,
    'zh-TW': zhTW
  },
  // 添加消息编译选项以防止链接格式错误
  messageCompiler: {
    // 禁用链接消息功能以避免格式错误
    allowDynamic: false,
    // 严格模式检查
    strict: false,
    // 错误处理
    onError: (error, source) => {
      console.warn('i18n message compilation error:', error, 'source:', source)
    }
  },
  // 错误处理
  missingWarn: false,
  fallbackWarn: false,
  // 运行时编译选项
  runtimeOnly: false
})

export default i18n
